import { ICreateBedReponse, ICreateRoomRequest, ICreateRoomReponse, IPropertyOptionResponse, ICreateBedRequest, IViewRoomDurationReponse, IUpdateRoomDurationRequest, IUpdateRoomDurationResponse, IUpdateBedDurationRequest, IUpdateBedDurationResponse, ICreatePropertyRequest, ICreatePropertyResponse, IViewBedDurationReponse } from '../../app/model/hostModel';
import { IKeywordSearchRequest, IShortTermProperty, IShortTermSearchRequest } from '../../app/model/guestModel';
import { API_CREATE_BED, API_CREATE_HOST_PROPERTY, API_DELETE_HOST_PROPERTY, API_GET_BED_DURATION, API_GET_HOST_PROPERTY, API_GET_ROOM_DURATION, API_GET_VIEW_BED, API_GET_VIEW_ROOM, API_UPDATE_BED, API_UPDATE_BED_DURATION, API_UPDATE_HOST_PROPERTY, API_UPDATE_ROOM, API_UPDATE_ROOM_DURATION, API_CREATE_ROOM, API_GET_SINGLE_PROPERTY, API_HOST_KEYWORD_BASED_SEARCH } from '../config';
import { apiClient, userApiClient } from '../HttpClient';

export async function getKeywordBasedSearch(
  request: IKeywordSearchRequest
): Promise<any> {
  try {
    const params = new URLSearchParams();

    if (request?.keyword) {
      params.append("keyword", request.keyword);
    }
    if (request?.checkin) {
      params.append("check_in", request.checkin);
    }
    if (request?.checkout) {
      params.append("check_out", request.checkout);
    }
    if (request?.accommodation_type) {
      params.append("accommodation_type", request.accommodation_type);
    }
    if (request?.male_guests !== undefined && request?.male_guests !== null) {
      params.append("male_guests", request.male_guests.toString());
    }
    if (request?.female_guests !== undefined && request?.female_guests !== null) {
      params.append("female_guests", request.female_guests.toString());
    }
    if (request?.property_id) {
      params.append("property_id", request.property_id);
    }
    if (request?.price_min) {
      params.append("price_min", request.price_min.toString());
    }
    if (request?.price_max) {
      params.append("price_max", request.price_max.toString());
    }
    if (request?.property_type) {
      request.property_type.forEach(pt => params.append("property_type", pt));
    }
    if (request?.amenities) {
      request.amenities.forEach(am => params.append("amenities", am));
    }
    if (request?.rating) {
      params.append("rating", request.rating.toString());
    }

    const url = `${API_HOST_KEYWORD_BASED_SEARCH}?${params.toString()}`;
    const client = await userApiClient;
    const response = await client.get<any>(url);

    return response;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    const errorMessage = error?.response?.data?.errorMessage || "An error occurred";
    throw new Error(errorMessage);
  }
}

export async function getShortTermSearch(
  request: IShortTermSearchRequest & { property_id?: string }
): Promise<IShortTermProperty[]> {
  try {
    const params = new URLSearchParams();
    if (request.keyword) params.append('keyword', request.keyword);
    if (request.property_id) params.append('property_id', request.property_id);
    params.append('check_in', request.checkin);
    params.append('check_out', request.checkout);
    params.append('accommodation_type', request.accommodation_type);
    if (request.male_guests) params.append('male_guests', request.male_guests.toString());
    if (request.female_guests) params.append('female_guests', request.female_guests.toString());
    if (request.price_min) params.append('price_min', request.price_min.toString());
    if (request.price_max) params.append('price_max', request.price_max.toString());
    const url = `${API_HOST_KEYWORD_BASED_SEARCH}?${params.toString()}`;
    const client = await userApiClient;
    return client.get<IShortTermProperty[]>(url);
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Search failed');
  }
}

//Home page property dropdown
export async function getHostProprtyOptions(organizationID: string): Promise<IPropertyOptionResponse[]> {
  try {
    const client = await apiClient;
    const response = await client.get<IPropertyOptionResponse[]>(API_GET_HOST_PROPERTY.replace('organizationID', organizationID));
    return response;
  } catch (error: any) {
    const errorMessage = error?.status
    return errorMessage;
  }
}

export async function getPropertyDetails(propertyID: string): Promise<any> {
  try {
    const client = await apiClient;
    const response = await client.get<any>(API_GET_SINGLE_PROPERTY.replace('propertyID', propertyID.toString()));
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function createProperty(formData: any): Promise<ICreatePropertyResponse> {
  try {
    const client = await apiClient;
    const response = await client.post<ICreatePropertyResponse>(API_CREATE_HOST_PROPERTY, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function updateProperty(propertyID: string, request: ICreatePropertyRequest): Promise<ICreatePropertyResponse> {
  try {
    const client = await apiClient;
    const response = await client.put<ICreatePropertyResponse>(API_UPDATE_HOST_PROPERTY.replace('propertyID', propertyID.toString()), request);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function deleteProperty(propertyID: string): Promise<any> {
  try {
    const client = await apiClient;
    const response = await client.delete<any>(API_DELETE_HOST_PROPERTY.replace('propertyID', propertyID.toString()));
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

//Create Room Availability

export async function getViewRoom(propertyID: string): Promise<any> {
  try {
    const client = await apiClient;
    const response = await client.get<any>(API_GET_VIEW_ROOM +'?property_id=' + propertyID);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function createRoom(request: ICreateRoomRequest): Promise<ICreateRoomReponse[]> {
  try {
    const client = await apiClient;
    const response = await client.post<ICreateRoomReponse[]>(API_CREATE_ROOM, request);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function updateRoom(roomID: number, request: ICreateRoomRequest): Promise<ICreateRoomReponse[]> {
  try {
    const client = await apiClient;
    const response = await client.put<ICreateRoomReponse[]>(API_UPDATE_ROOM.replace('roomID', roomID.toString()), request);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function deleteRoom(roomID: number): Promise<any> {
  try {
    const client = await apiClient;
    const response = await client.delete<any>(API_UPDATE_ROOM.replace('roomID', roomID.toString()));
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

//Create Bed Availability

export async function getViewBed(propertyID: string): Promise<any> {
  try {
    const client = await apiClient;
    const response = await client.get<any>(API_GET_VIEW_BED+'?property_id=' + propertyID);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function createBed(request: ICreateBedRequest): Promise<ICreateBedReponse[]> {
  try {
    const client = await apiClient;
    const response = await client.post<ICreateBedReponse[]>(API_CREATE_BED, request);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function updateBed(roomID: number, request: ICreateBedRequest): Promise<ICreateBedReponse[]> {
  try {
    const client = await apiClient;
    const response = await client.put<ICreateRoomReponse[]>(API_UPDATE_BED.replace('roomID', roomID.toString()), request);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function patchBed(bedId: string, data: { auto_list: boolean }): Promise<any> {
  const client = await apiClient;
  return client.patch<any>(API_UPDATE_BED.replace('roomID', bedId), data);
}

export async function patchRoom(roomId: string, data: { auto_list: boolean }): Promise<any> {
  const client = await apiClient;
  return client.patch<any>(API_UPDATE_ROOM.replace('roomID', roomId), data);
}

export async function deleteBed(roomID: number): Promise<any> {
  try {
    const client = await apiClient;
    const response = await client.delete<any>(API_UPDATE_BED.replace('roomID', roomID.toString()));
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function deletePropertyImage(imageId: number): Promise<any> {
  try {
    const client = await apiClient;
    const response = await client.delete<any>(`/api/hosts/property-images/${imageId}/`);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

//Update Room Availability

export async function getViewRoomDuration(propertyID: string): Promise<IViewRoomDurationReponse[]> {
  try {
    const client = await apiClient;
    const response = await client.get<IViewRoomDurationReponse[]>(API_GET_ROOM_DURATION.replace('propertyID', propertyID.toString()));
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function updateRoomDuration(roomID: number, request: IUpdateRoomDurationRequest): Promise<IUpdateRoomDurationResponse[]> {
  try {
    const client = await apiClient;
    const response = await client.put<IUpdateRoomDurationResponse[]>(API_UPDATE_ROOM_DURATION.replace('roomID', roomID.toString()), request);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

//Update Bed Availability

export async function getViewBedDuration(propertyID: string): Promise<IViewBedDurationReponse[]> {
  try {
    const client = await apiClient;
    const response = await client.get<IViewBedDurationReponse[]>(API_GET_BED_DURATION.replace('propertyID', propertyID.toString()));
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

export async function updateBedDuration(bedAvailabilityID: string, request: IUpdateBedDurationRequest): Promise<IUpdateBedDurationResponse> {
  try {
    const client = await apiClient;
    const response = await client.put<IUpdateBedDurationResponse>(API_UPDATE_BED_DURATION.replace('bedID', bedAvailabilityID.toString()), request);
    return response;
  } catch (error: any) {
    const errorMessage = error?.status;
    return errorMessage;
  }
}

//property

// New interface for the ratings response
export interface IRatingsResponse {
  property_id: string;
  year: number;
  month: number;
  averages: {
    cleaning: number;
    internet: number;
    food: number;
  };
  reviews: {
    feedback_text: string;
    rating__tenant__name: string;
  }[];
}

// New function to get property ratings
export async function getPropertyRatings(propertyId: string, year: number, month: number): Promise<IRatingsResponse> {
  try {
    const client = await apiClient;
    // Assuming the gateway routes /api/pg-tenant/ to the pg_tenant_service
    const url = `/api/pg_tenant/property/${propertyId}/ratings/?year=${year}&month=${month}`;
    const response = await client.get<IRatingsResponse>(url);
    return response;
  } catch (error: any) {
    console.error("Failed to fetch property ratings:", error);
    throw error;
  }
}
